import { useEffect, useState } from 'react';
import api from '../../api/endpoints';
import PageHeader from '../../components/PageHeader';
import { Empty, Loading, Rating } from '../../components/Ui';
import { Reveal, stagger } from '../../components/Motion';
import { colors } from '../../theme';
import { shortDate, titleCase } from '../../utils/format';

const MyReviewsPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.reviews.mine()
      .then((res) => setItems(res.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="My reviews" subtitle={`${items.length} written`} />

      {loading ? <Loading /> : !items.length ? (
        <Empty
          emoji="⭐"
          title="No reviews yet"
          text="Rate a completed order or booking to help others choose."
        />
      ) : (
        <div className="grid grid-list">
          {items.map((item, i) => (
            <Reveal key={item._id} delay={stagger(i, 50)} className="card sh-sm">
              <div className="row-between">
                <Rating value={item.rating} size={14} />
                <span className="t-tiny">{shortDate(item.createdAt)}</span>
              </div>
              <div className="t-tiny" style={{ marginTop: 4 }}>{titleCase(item.targetType)} review</div>
              {item.comment ? (
                <p className="t-body" style={{ marginTop: 8, lineHeight: 1.6 }}>{item.comment}</p>
              ) : null}
              {item.reply ? (
                <div style={{ background: colors.bg, padding: 12, borderRadius: 12, marginTop: 12 }}>
                  <span className="t-small">↩︎ {item.reply}</span>
                </div>
              ) : null}
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyReviewsPage;
